export default {
  // Page metadata
  'meta.title': 'شروط الخدمة - timer.today',
  'meta.description': 'شروط الخدمة واتفاقية الاستخدام لمنصة أدوات التوقيت عبر الإنترنت timer.today. تعرف على قواعد خدمتنا وحقوق ومسؤوليات المستخدمين.',

  // Page header
  'page.title': 'شروط الخدمة',
  'page.lastUpdated': 'آخر تحديث: {{date}}',
  'page.intro': 'مرحبًا بك في timer.today. توضح هذه الشروط والأحكام القواعد واللوائح الخاصة باستخدام موقع timer.today الموجود على timer.today.',

  // Section 1
  'section1.title': '1. قبول الشروط',
  'section1.content': 'من خلال الوصول إلى هذا الموقع واستخدامه، فإنك تقبل وتوافق على الالتزام بشروط وأحكام هذه الاتفاقية. إذا كنت لا توافق على الالتزام بما سبق، يرجى عدم استخدام هذه الخدمة.',

  // Section 2
  'section2.title': '2. وصف الخدمة',
  'section2.intro': 'يوفر timer.today أدوات توقيت مجانية عبر الإنترنت بما في ذلك:',
  'section2.timer': 'مؤقت العد التنازلي - مؤقت قابل للتخصيص للإنتاجية والطبخ وإدارة الوقت',
  'section2.stopwatch': 'ساعة الإيقاف - أداة توقيت عالية الدقة للرياضة والتدريب والتوقيت الدقيق',
  'section2.worldclock': 'الساعة العالمية - عرض في الوقت الفعلي للمناطق الزمنية العالمية',

  // Section 3
  'section3.title': '3. ترخيص الاستخدام',
  'section3.intro': 'يُمنح الإذن باستخدام timer.today مؤقتًا للعرض الشخصي غير التجاري والعابر فقط. هذا هو منح ترخيص، وليس نقل ملكية، وبموجب هذا الترخيص لا يجوز لك:',
  'section3.item1': 'تعديل أو نسخ المواد',
  'section3.item2': 'استخدام المواد لأي غرض تجاري أو لأي عرض عام',
  'section3.item3': 'محاولة إجراء هندسة عكسية لأي برنامج موجود على الموقع',
  'section3.item4': 'إزالة أي حقوق طبع ونشر أو إشعارات ملكية أخرى من المواد',

  // Section 4
  'section4.title': '4. الخصوصية والبيانات',
  'section4.intro': 'يلتزم timer.today بحماية خصوصيتك:',
  'section4.item1': 'نحن لا نجمع أو نخزن معلومات شخصية',
  'section4.item2': 'يتم تخزين إعدادات المؤقت محليًا في متصفحك',
  'section4.item3': 'نحن لا نتتبع سلوك المستخدم أو أنماط الاستخدام',
  'section4.item4': 'لا يتم استخدام ملفات تعريف الارتباط لأغراض التتبع',

  // Section 5
  'section5.title': '5. إخلاء المسؤولية',
  'section5.content': 'يتم توفير المواد الموجودة على timer.today "كما هي". لا يقدم timer.today أي ضمانات، صريحة أو ضمنية، ويخلي مسؤوليته بموجب هذا وينفي جميع الضمانات الأخرى بما في ذلك، على سبيل المثال لا الحصر، الضمانات الضمنية أو شروط القابلية للتسويق، أو الملاءمة لغرض معين، أو عدم انتهاك الملكية الفكرية أو غيرها من انتهاكات الحقوق.',

  // Section 6
  'section6.title': '6. القيود',
  'section6.content': 'لن يكون timer.today أو مورديه مسؤولين بأي حال من الأحوال عن أي أضرار (بما في ذلك، على سبيل المثال لا الحصر، الأضرار الناجمة عن فقدان البيانات أو الربح، أو بسبب انقطاع الأعمال) الناشئة عن استخدام أو عدم القدرة على استخدام المواد الموجودة على timer.today، حتى لو تم إخطار timer.today أو ممثله المعتمد شفهيًا أو كتابيًا بإمكانية حدوث مثل هذا الضرر.',

  // Section 7
  'section7.title': '7. دقة المواد',
  'section7.content': 'قد تتضمن المواد التي تظهر على timer.today أخطاء فنية أو مطبعية أو فوتوغرافية. لا يضمن timer.today أن أيًا من المواد الموجودة على موقعه الإلكتروني دقيقة أو كاملة أو حديثة. قد يجري timer.today تغييرات على المواد الموجودة على موقعه الإلكتروني في أي وقت دون إشعار.',

  // Section 8
  'section8.title': '8. التعديلات',
  'section8.content': 'قد يقوم timer.today بمراجعة شروط الخدمة هذه لموقعه الإلكتروني في أي وقت دون إشعار. باستخدامك لهذا الموقع، فإنك توافق على الالتزام بالإصدار الحالي من شروط الخدمة هذه.',

  // Section 9
  'section9.title': '9. معلومات الاتصال',
  'section9.intro': 'إذا كان لديك أي أسئلة حول شروط الخدمة هذه، يرجى الاتصال بنا على:',
  'section9.email': 'البريد الإلكتروني:',
  'section9.emailSubject': 'استفسار عن شروط الخدمة - timer.today',

  // Footer
  'footer.copyright': '© timer.today 2024. جميع الحقوق محفوظة.'
};
